import { render, staticRenderFns } from "./floatDownload.vue?vue&type=template&id=32079fcc&scoped=true&"
import script from "./floatDownload.vue?vue&type=script&lang=js&"
export * from "./floatDownload.vue?vue&type=script&lang=js&"
import style0 from "./floatDownload.vue?vue&type=style&index=0&id=32079fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32079fcc",
  null
  
)

export default component.exports